<template>
    <v-dialog
    v-model="isDialogOpen"
    persistent
    max-width="640">
    <v-card>
      <v-card-title class="title-form">
        {{isEdit
          ? 'Editar colaborador'
          :'Agregar colaborador'}}
      </v-card-title>
      <v-card-text>
        <div class="container-form">
          <v-select
            label="Seleccionar rol"
            v-model="collaborator.role"
            :items="itemsRoles"
            :rules="rules.required"
            item-title="name"
            item-value="_id"
            variant="underlined"/>
          <v-select
            label="Asociar a POS"
            v-model="collaborator.terminal"
            :items="pos"
            :rules="rules.required"
            item-title="name"
            item-value="_id"
            variant="underlined"/>
          <v-text-field
            label="Nombre completo"
            placeholder="Nombre completo"
            v-model="collaborator.name"
            color="#222222"
            variant="underlined"
            type="text"
            :rules="rules.required"/>
          <v-text-field
            label="Email"
            placeholder="Email"
            v-model="collaborator.email"
            color="#222222"
            variant="underlined"
            type="text"
            :rules="rules.required"
            autocomplete="off"/>
          <v-text-field
            v-if="!isEdit"
              label="Contraseña"
              placeholder="Contraseña"
              v-model="collaborator.password"
              color="#222222"
              variant="underlined"
              :type="showedPassword ? 'text' : 'password'"
              :rules="rules.required"
              autocomplete="off">
            <template v-slot:append-inner>
              <v-icon color="#222222" icon="mdi-eye-outline" size="small" v-if="!showedPassword" v-on:click="showedPassword = !showedPassword"/>
              <v-icon color="#222222" icon="mdi-eye-off-outline" size="small" v-if="showedPassword" v-on:click="showedPassword = !showedPassword"/>
            </template>
          </v-text-field>

          <v-text-field
            label="Pin"
            placeholder="Pin"
            v-model="collaborator.pin"
            color="#222222"
            variant="underlined"
            :type="showedPin ? 'text' : 'password'"
            :rules="rules.required"
            autocomplete="off"
            maxlength="4"
             @input="collaborator.pin = collaborator.pin.replace(/\D/g, '').slice(0,4)">
            <template v-slot:append-inner>
              <v-icon color="#222222" icon="mdi-eye-outline" size="small" v-if="!showedPin" v-on:click="showedPin = !showedPin"/>
              <v-icon color="#222222" icon="mdi-eye-off-outline" size="small" v-if="showedPin" v-on:click="showedPin = !showedPin"/>
            </template>
          </v-text-field>

        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          class="btn-cancel-form"
          color="#6E6E6E"
          variant="text"
          rounded="xl"
          @click="isDialogOpen = false">
          Cancelar
        </v-btn>
        <v-btn
          class="btn-action-form"
          rounded="xl"
          color="#FFFFFF"
          :loading="isSavingData"
          :disabled="disableBtn()"
          @click="actionBtn">
          Guardar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>
<script>
import terminalsApi from '@/api/terminalsApi'
import colaboratorsApi from '@/api/collaboratorsApi'
export default {
  name: 'CommerciaVueAddEditCollaborators',
  emits: ['refreshList'],
  data () {
    return {
      validData: true,
      isSavingData: false,
      isDialogOpen: false,
      showedPassword: false,
      showedPin: false,
      isEdit: false,
      itemsRoles: [
        'Administrador',
        'Cajero',
        'Cliente',
        'Manager',
        'Finanzas'
      ],
      business: this.$store.getters.business,
      pos: [],
      collaborator: this.initObj(),
      rules: {
        required: [
          v => !!v || 'Campo requerido.'
        ],
        validEmail: [
          (v) => !!v || 'Campo requerido.',
          (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) || 'Email no válido'
        ]
      }
    }
  },
  created () {
    this.getPos()
  },
  methods: {
    initObj () {
      return {
        business: null,
        terminal: null,
        role: null,
        name: null,
        email: null,
        active: null,
        password: null,
        _id: null,
        created_at: null,
        updated_at: null,
        pin: null
      }
    },
    add () {
      this.collaborator = this.initObj()
      this.collaborator._id = '-'
      this.collaborator.updated_at = Date.now()
      this.collaborator.created_at = Date.now()
      this.collaborator.business = this.business._id
      this.collaborator.active = true
      this.isDialogOpen = true
      this.isEdit = false
    },
    edit (collaborator) {
      this.collaborator.password = '-'
      this.isDialogOpen = true
      this.isEdit = true
      this.collaborator = structuredClone(collaborator)
      this.collaborator.role = this.collaborator.role.description
      this.collaborator.terminal = this.collaborator.terminal._id
    },
    disableBtn () {
      return (Object.values(this.collaborator).some(value => value === null || value === '') ||
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(this.collaborator.email))
    },
    actionBtn () {
      if (this.isEdit) {
        this.editCollaborator()
      } else {
        this.addCollaborator()
      }
    },
    async getPos () {
      this.pos = await terminalsApi.list(this.business._id, '')
    },
    async addCollaborator () {
      if (await colaboratorsApi.add(this.collaborator)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
        // mostar el error
      }
    },
    async editCollaborator () {
      if (await colaboratorsApi.edit(this.collaborator)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
        // mostar el error
      }
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/forms.css';
</style>
